module.exports = __webpack_public_path__ + "static/media/video-letgo-es.835e8524.vtt";